<template lang="pug">
  // メール変更完了画面
  #change-mail-done
    header-for-login
    template(v-if="isLoading === true")
      loading(:height="200")
    template(v-else)
      b-card.text-center.mx-auto.body-width.pb-2(header-tag="header")
        change-mail-form-done(:mail_address="mail_address")
</template>

<script>
import HeaderForLogin from "@/components/supportSite/HeaderForLogin";
import ChangeMailFormDone from "@/components/supportSite/ChangeMailFormDone";
import Loading from '@/components/Loading';

import Api from "@/repositories/api";
const S207MailChanges = Api.get("s207MailChanges");

export default {
  name: "ChangeMailDone",
  components: {
    Loading,
    ChangeMailFormDone,
    HeaderForLogin,
  },
  props: {
    mail_address: { type: String, required: false }
  },
  data() {
    return {
      // メール変更トークン
      token: "",

      // 読み込み中フラグ
      isLoading: false,
    }
  },
  created() {
    // 読み込み開始
    this.isLoading = true;

    // クエリパラメータからトークン取得
    this.token = this.$route.query.token;

    // リクエストパラメータ作成
    let requestParameter = {
      token: this.token
    };

    // トークンの存在チェックとメールアドレス変更処理
    S207MailChanges.edit(requestParameter)
    // 失敗
    .catch((error) => {
      // httpステータスコードが403の場合（権限エラー）
      if (error.response.status === 403) {
        // アプリケーションエラー画面へ遷移する
        this.$router.push({
          name: 'SupportApplicationError',
          params: {
            // 画面に表示するエラーメッセージ
            error_msg: this.forbidden_message
          }
        })
      }

      this.apiError(error, "変更処理")

      // バリデーションエラー
      if (error.response.data && error.response.data.error_list) {
        // 全てのエラーメッセージを確認
        for (let errorData of error.response.data.error_list) {
          // エラーメッセージの項目が指定されている場合
          if (errorData.target !== undefined && this[errorData.target] !== undefined) {
            this[errorData.target].error_msg_list.push(errorData.error_msg)
          }
          // エラーメッセージの項目がない場合
          else {
            // エラー用の画面へ遷移する
            this.$router.push({
              name: "RelatedPasswordSetting",
              params: {
                // 画面に表示するエラーメッセージ
                error_msg: errorData.error_msg
              }
            })
          }
        }
      }
    })
    .finally(() => {
      // 読み込み終了
      this.isLoading = false;
    })
  },
}
</script>

<style scoped>
.body-width {
  max-width: 1200px;
  /*max-width: 1123px;*/
}
</style>